import { createMuiStyles } from '../../utils/mui';

export const resetForgotPasswordPageStyles = createMuiStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
  card: {
    p: 5,
    borderRadius: '0.5rem',
    bgcolor: 'grey.50',
    textAlign: 'center',
    width: 'min(37.5rem, 100%)',
  },
  svg: {
    height: '15rem',
    width: '15rem',
    mb: 5,
  },
});
